import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';

import { AuthService } from '../../services/auth.service';
import { JossoService } from '../../services/josso.service';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
	arit: boolean = false;
	josso_username: string;
	josso_password: string;

	constructor(
		private authService: AuthService,
		private jossoService: JossoService,
		private router: Router,
		private cookieService: CookieService
		) { }

	ngOnInit() {
	 if(this.authService.loggedIn()){
      console.log("CMP|LOGIN - loggedin navigate", this.authService.lastVisited);
      this.router.navigate([this.authService.lastVisited]);
    //}else if(this.authService.ssoSessionId){
    }else if(this.jossoService.ssoSessionId){
      console.log("CMP|LOGIN - ssoSessionId navigate", this.jossoService.ssoSessionId);
      this.router.navigate(['/check-access']);
    }else{
      console.log("CMP|LOGIN - no logged no sessionID");
    }
	}

	onLoginSubmit() {
		this.jossoService.sendingLogout = false;
		let login = {
			josso_username: this.josso_username,
			josso_password: this.josso_password,
		};
		this.authService.authenticateAritUser(login);

	}

	goToRegistration() {
		window.location.href = 'http://idm.egov.regione.abruzzo.it/web/guest/home?p_p_id=IdMCentralContentDisplay_WAR_idmcentralcontainerportlet&p_p_lifecycle=1&p_p_state=normal&p_p_mode=view&p_p_col_id=column-1&p_p_col_count=1&_IdMCentralContentDisplay_WAR_idmcentralcontainerportlet_section_container=reg_user&back_url=http://www.rari.egov.regione.abruzzo.it&back_label=RARI%20E-gov';
	}

	goToPasswordRecovery() {
		window.location.href = 'http://idm.egov.regione.abruzzo.it/web/guest/home?p_p_id=IdMCentralContentDisplay_WAR_idmcentralcontainerportlet&p_p_lifecycle=1&p_p_state=normal&p_p_mode=view&p_p_col_id=column-1&p_p_col_count=1&_IdMCentralContentDisplay_WAR_idmcentralcontainerportlet_section_container=rec_pass';
	}

	goToUsernameRecovery() {
		window.location.href = 'http://idm.egov.regione.abruzzo.it/web/guest/home?p_p_id=IdMCentralContentDisplay_WAR_idmcentralcontainerportlet&p_p_lifecycle=1&p_p_state=normal&p_p_mode=view&p_p_col_id=column-1&p_p_col_count=1&_IdMCentralContentDisplay_WAR_idmcentralcontainerportlet_section_container=rec_username';
	}

	goToBackend() {
		//console.log("CMP|LOGIN - navigate backend");
		this.router.navigate(['/backend']);
	}
}
